import { Component, Prop, h, Event, EventEmitter, Host } from '@stencil/core';

/**
 * @slot default - Slot for text content in chip
 */

@Component({
  tag: 'uui-filterchip',
  styleUrl: 'uui-filter-chip.css',
  shadow: true
})
export class UUIFilterChip {
  @Event({ bubbles: true, composed: true }) action: EventEmitter;
  @Event({ bubbles: true, composed: true }) contentAction: EventEmitter;

  @Prop({ reflect: true }) variant: 'unselected' | 'selected' | 'more' =
    'selected';
  @Prop({ reflect: true }) size: 'small' | 'large' = 'large';
  @Prop({ reflect: true }) width: string = 'auto';
  /** max width to apply to tooltip content. If content is longer, this will render an ellipsis */
  @Prop({ reflect: true }) maxWidth: string = 'auto';
  @Prop({ reflect: false }) count: string = '0';
  /** prevent filter chip being removed */
  @Prop({ reflect: true }) readonly: boolean = false;
  @Prop() class: string = '';
  /** title to render on hover of tooltip */
  @Prop() htmlTitle: string = '';

  onButtonClick(event) {
    this.action.emit(event);
  }
  onContentClick(event) {
    this.contentAction.emit(event);
  }

  render() {
    let classes = `uui-filter-chip-container uui-filter-chip-${this.size} uui-filter-chip-${this.variant}`;

    let rightContent = null;

    if (this.variant === 'selected') {
    }
    rightContent = (
      <svg
        height="18px"
        width="18px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" />
      </svg>
    );

    if (this.variant == 'unselected') {
      rightContent = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18px"
          width="18px"
          viewBox="0 0 384 512"
        >
          <path d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z" />
        </svg>
      );
    }

    if (this.variant == 'more') {
      rightContent = <div class="bubble">{this.count}</div>;
    }

    if (this.size === 'small') {
      return (
        <Host>
          <button
            slot="input-icon"
            onClick={this.onButtonClick.bind(this)}
            class={`uui-button-no-styles uui-filter-chip-margin uui-filter-button`}
          >
            <div class={classes} style={{ width: this.width }}>
              <span class="uui-filter-chip-icon-container">{rightContent}</span>
              <span
                class="content"
                style={{ maxWidth: this.maxWidth }}
                title={this.htmlTitle}
              >
                <slot />
              </span>
            </div>
          </button>
        </Host>
      );
    }
    if (this.variant === 'unselected') {
      return (
        <Host>
          <button
            slot="input-icon"
            title={this.htmlTitle}
            aria-label={this.htmlTitle}
            onClick={this.onButtonClick.bind(this)}
            class="uui-button-no-styles uui-filter-button uui-filter-chip-margin"
          >
            <span class={classes} style={{ width: this.width }}>
              <span
                class="content"
                style={{ maxWidth: this.maxWidth }}
                title={this.htmlTitle}
              >
                <slot />
              </span>
              {rightContent}
            </span>
          </button>
        </Host>
      );
    }

    return (
      <Host>
        <div
          class={`${classes} uui-filter-chip-margin ${this.class}`}
          style={{ width: this.width, maxWidth: this.maxWidth }}
          title={this.htmlTitle}
        >
          <span class="content" onClick={this.onContentClick.bind(this)}>
            <slot />
          </span>
          <button
            slot="input-icon"
            title={this.htmlTitle}
            aria-label={this.htmlTitle}
            class={`uui-button-no-styles uui-filter-button`}
            onClick={this.onButtonClick.bind(this)}
          >
            {rightContent}
          </button>
        </div>
      </Host>
    );
  }
}
